export default __webpack_public_path__ + "static/media/NotoSans-Bold.5f7ac340.ttf";